import { create } from 'zustand';

type TemporaryTrustedAccessState = {
  dirtyByIdentityId: Record<string, number>;
  markDirty: (identityId: string) => void;
  clearDirty: (identityId: string) => void;
  clearDirtyMany: (identityIds: string[]) => void;
};

export const useTemporaryTrustedAccessStore = create<TemporaryTrustedAccessState>((set) => ({
  dirtyByIdentityId: {},
  markDirty: (identityId) => set((state) => ({
    dirtyByIdentityId: {
      ...state.dirtyByIdentityId,
      [identityId]: Date.now()
    }
  })),
  clearDirty: (identityId) => set((state) => {
    if (!state.dirtyByIdentityId[identityId]) return state;
    const next = { ...state.dirtyByIdentityId };
    delete next[identityId];
    return { dirtyByIdentityId: next };
  }),
  clearDirtyMany: (identityIds) => set((state) => {
    if (identityIds.length === 0) return state;
    const next = { ...state.dirtyByIdentityId };
    let changed = false;
    for (const identityId of identityIds) {
      if (!next[identityId]) continue;
      delete next[identityId];
      changed = true;
    }
    return changed ? { dirtyByIdentityId: next } : state;
  })
}));
